import fp from 'lodash/fp'

export class SlotHostController {
  constructor() {
    this.waitTrackers = new Map()
    this.waitList = []
    window.SlotHostController = this
  }

  waitFor(slotName, injector) {
    if (this.waitTrackers.has(slotName)) {
      const slotWaitTrackers = this.waitTrackers.get(slotName)

      if (slotWaitTrackers.includes(injector)) {
        throw new Error(
          `Slot host controller already contains trackers for slot [${slotName}]`
        )
      }

      slotWaitTrackers.push(injector)
    } else {
      this.waitTrackers.set(slotName, [injector])
    }

    this.flushWaitList(slotName)

    return () => {
      this.remove(slotName, injector)
    }
  }

  hasWaitTrackers(slotName) {
    return this.waitTrackers.has(slotName)
  }

  render(slotName, component) {
    if (this.hasWaitTrackers(slotName)) {
      for (const tracker of this.waitTrackers.get(slotName)) {
        tracker(component)
      }

      return
    }

    this.waitList.push([slotName, component])
  }

  remove(slotName, injector) {
    if (this.waitTrackers.has(slotName)) {
      const slotWaitTrackers = this.waitTrackers.get(slotName)
      const index = slotWaitTrackers.indexOf(injector)

      if (index === -1) {
        throw new Error(
          `Slot host controller has no injector for slot [${slotName}]`
        )
      }

      slotWaitTrackers.splice(index, 1)
    }
  }

  flushWaitList(slotName) {
    const [readyList, stillWait] = fp.partition(
      ([name]) => name === slotName,
      this.waitList
    )

    this.waitList = stillWait

    for (const [name, component] of readyList) {
      this.render(name, component)
    }
  }

  dispose() {
    this.waitTrackers.clear()
    this.waitList.length = 0
  }
}
